import { GridActionsCellItem, GridActionsCellItemProps } from '@mui/x-data-grid'
import { createLink } from '@tanstack/react-router'

const InnerLink: React.FC<
    React.PropsWithChildren<
        { ref: React.RefObject<HTMLAnchorElement> } & GridActionsCellItemProps
    >
> = ({ children, ref, ...props }) => (
    <GridActionsCellItem component={'a'} ref={ref} {...(props as any)}>
        {children}
    </GridActionsCellItem>
)

export const GridActionsCellItemLink = createLink(InnerLink)
